import type { ElementalType, ElementalTypeEnum } from '../types/elemental'

export function getElementalMetadata(defaultTypeId: ElementalTypeEnum): ElementalType | null {
  const idType = defaultTypeId ?? 1
  return useElementalTypes().value.find(e => e.id === idType) ?? null
}
